import script from "./CarouselItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarouselItem.vue?vue&type=script&lang=ts&setup=true"

import "./CarouselItem.vue?vue&type=style&index=0&id=f60510b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f60510b6"]])

export default __exports__